import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "到仓情况", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 件 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 斤 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 斤 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 度 ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "收货照片", -1)
const _hoisted_8 = {
  key: 0,
  class: "bottom-btn"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("提交")

import { Field, CellGroup, Button, Notify, ImagePreview } from 'vant';
import { onMounted, ref } from 'vue';
import { getFileToken } from "../../../api/user";
import { getQinNiuTokenApi, getAgentDeliverOrderApi, postAgentDeliverOrderApi } from "../../../api/production";
import { dateFormat, directUploadFile } from "@/utils/util";
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const receivingTime = dateFormat()
const route = useRoute()
const router = useRouter()
const state = ref({
	token: route.query.token,
	id: "",
	dateShow: false,
	minDate: new Date(1970, 0, 1),
	maxDate: new Date(2040, 12, 31),
	currentDate: new Date(),
	orderId: "",
	dispatchNoteId: "",
	receivingTime: receivingTime.YYYY + '-' + receivingTime.MM + '-' + receivingTime.DD + ' ' + receivingTime.hh + ':' + receivingTime.mm,
	receivingTimeErrMsg: "",
	receivingUser: { id: "", name: "" },
	receivingUserErrMsg: "",
	projectErrMsg: "",
	cooperation: { id: "", name: "" },
	cooperationErrMsg: "",
	warehouseName: "",
	warehouseNameErrMsg: "",
	sn: "",
	product: { id: "", name: "" },
	productClass: { id: "", name: "" },
	productUnit: { id: "", name: "" },
	number: "",
	numberErrMsg: "",
	deliveryQuantity: "",
	deliveryQuantityErrMsg: "",
	deliveryGrossWeight: "",
	deliveryNetWeight: "",
	deliveryTemperature: "",
	deliveryTemperatureErrMsg: "",
	remark: "",
	loadingConditionImg: [],//装车情况
	loadingConditionImgErrMsg: false,//装车情况
	packingConditionImg: [],//包装情况
	packingConditionImgErrMsg: false,//包装情况
	appearanceImg: [],//商品外观
	appearanceImgErrMsg: false,//商品外观
	sugarImg: [],//商品糖度测试
	sugarImgErrMsg: false,//商品糖度测试
	otherImg: [],//其他
	otherImgErrMsg: false,//其他
	docmHeight: document.documentElement.clientHeight,  // 默认屏幕高度
	showHeight: document.documentElement.clientHeight,   // 实时屏幕高度
	hideshow: true // 显示或者隐藏
})
window.onresize = ()=>{
	state.value.showHeight = document.documentElement.clientHeight
	if(state.value.docmHeight > state.value.showHeight) {
		state.value.hideshow = false
	} else {
		state.value.hideshow = true
	}
}

const confirmDateSelect = (e: any) => {
	const tempDate = dateFormat(e);
	state.value.receivingTime = tempDate.YYYY + "-" + tempDate.MM + "-" + tempDate.DD + ' ' + tempDate.hh + ':' + tempDate.mm;
	state.value.currentDate = new Date(state.value.receivingTime)
	popShowFn('dateShow', false)
};
const popShowFn = (name: any, boo: boolean, index: number = -1) => {
	(state.value as any)[name] = boo
}
const imageUploadAfter = async (e: any) => {
	if (Array.isArray(e)) {
		e.forEach(async (item) => {
			const result: any = await getQinNiuTokenApi({
				bucket: "xfarmer",
				fileType: 0,
				type: 2,
				token: "",
			});
			if (result.data.code == 0) {
				// 执行该函数后，获取数据请直接从双向绑定的数组中取值.
				directUploadFile(item, result.data, { userType: '2', fileType: '0' }, "");
			}
		});
	} else {
		const result: any = await getQinNiuTokenApi({
			bucket: "xfarmer",
			fileType: 0,
			type: 2,
			token: "",
		});
		if (result.data.code == 0) {
			directUploadFile(e, result.data, { userType: '2', fileType: '0' }, "");
		}
	}
};


const verify = () => {
	let tempData = state.value
	let isConfirm = true
	if (!tempData.receivingUser.id) {
		isConfirm = false
		var receivingUserErrMsg = "请选择收货人员"
	} else {
		var receivingUserErrMsg = ""
	}
	
	if (!tempData.warehouseName) {
		isConfirm = false
		var warehouseNameErrMsg = "请输入仓库名"
	} else {
		var warehouseNameErrMsg = ""
	}
	
	if (!tempData.cooperation.id) {
		isConfirm = false
		var cooperationErrMsg = "请选择供应商"
	} else {
		var cooperationErrMsg = ""
	}
	
	if (!tempData.number) {
		isConfirm = false
		var numberErrMsg = "请输入货物件数"
	} else {
		var numberErrMsg = ""
	}
	
	if (!tempData.deliveryQuantity) {
		isConfirm = false
		var deliveryQuantityErrMsg = "请选择到仓数量"
	} else {
		var deliveryQuantityErrMsg = ""
	}
	
	if (!tempData.deliveryTemperature) {
		isConfirm = false
		var deliveryTemperatureErrMsg = "请选择到仓温度"
	} else {
		var deliveryTemperatureErrMsg = ""
	}
	
	if (tempData.loadingConditionImg.length < 2) {
		isConfirm = false
		var loadingConditionImgErrMsg = true
	} else {
		var loadingConditionImgErrMsg = false
	}
	
	if (tempData.packingConditionImg.length < 2) {
		isConfirm = false
		var packingConditionImgErrMsg = true
	} else {
		var packingConditionImgErrMsg = false
	}
	
	if (tempData.appearanceImg.length < 2) {
		isConfirm = false
		var appearanceImgErrMsg = true
	} else {
		var appearanceImgErrMsg = false
	}
	
	if (tempData.sugarImg.length < 2) {
		isConfirm = false
		var sugarImgErrMsg = true
	} else {
		var sugarImgErrMsg = false
	}
	

	state.value = {
		...state.value,
		receivingUserErrMsg,
		cooperationErrMsg, numberErrMsg, deliveryQuantityErrMsg,
		deliveryTemperatureErrMsg, loadingConditionImgErrMsg, packingConditionImgErrMsg,
		sugarImgErrMsg, appearanceImgErrMsg, warehouseNameErrMsg
	}
	
	return isConfirm
}
const postInfo = () => {
	if (!verify()) {
		Notify({ type: "danger", message: "请完善信息" });
		return
	}
	let tempData = state.value
	let {
		appearanceImg, sugarImg, packingConditionImg,
		loadingConditionImg, otherImg
	} = tempData
	let appearanceImgIds = appearanceImg.map((item: any) => item.id).join(",")
	let sugarImgIds = sugarImg.map((item: any) => item.id).join(",")
	let packingConditionImgIds = packingConditionImg.map((item: any) => item.id).join(",")
	let loadingConditionImgIds = loadingConditionImg.map((item: any) => item.id).join(",")
	let otherImgIds = otherImg.map((item: any) => item.id).join(",")
	let obj: any = {
		orderId: tempData.orderId,
		dispatchNoteId: tempData.dispatchNoteId,
		receivingTime: tempData.receivingTime + ':00',
		receivingUserId: tempData.receivingUser.id,
		productClassCode: tempData.productClass.id,
		productClassName: tempData.productClass.name,
		cooperationId: tempData.cooperation.id,
		warehouseName: tempData.warehouseName,
		sn: tempData.sn,
		product: tempData.product.id,
		number: tempData.number,
		deliveryQuantity: tempData.deliveryQuantity,
		deliveryGrossWeight: tempData.deliveryGrossWeight,
		deliveryNetWeight: tempData.deliveryNetWeight,
		deliveryTemperature: tempData.deliveryTemperature,
		remark: tempData.remark,
		appearanceImgIds,
		sugarImgIds,
		packingConditionImgIds,
		loadingConditionImgIds,
		otherImgIds,
		token:tempData.token
	}
	postAgentDeliverOrderApi(obj).then((res: any) => {
		router.push({
			path:"/agent/agentSuccess"
		})
	})
}
const onDeleteImg = (item: any, index: number) => {
	if(index ==1){
	state.value.loadingConditionImg.splice(item.index, 1);
	}else if(2){
	state.value.packingConditionImg.splice(item.index, 1);
	}else if(3){
	state.value.appearanceImg.splice(item.index, 1);
	}else if(4){
	state.value.sugarImg.splice(item.index, 1);
	}else if(5){
	state.value.otherImg.splice(item.index, 1);
	}
}
const onClickImgPoster= ($event:any, index: number) => {
	var arr:any[] = []
	if(index ==1){
	 arr = state.value.loadingConditionImg
	}else if(2){
	 arr = state.value.packingConditionImg
	}else if(3){
	 arr = state.value.appearanceImg
	}else if(4){
	 arr = state.value.sugarImg
	}else if(5){
	 arr = state.value.otherImg
	}
	let temp = arr.map((items: any) => items.url);
    ImagePreview({
      images: temp,
      startPosition: 0,
    });
}
const getAgentDeliverOrder = () => {
	getAgentDeliverOrderApi({ token: state.value.token }).then((res: any) => {
		let tempData = res.data.data
		state.value.orderId = tempData.orderId
		state.value.dispatchNoteId = tempData.dispatchNoteId
		state.value.receivingUser = {
			name: tempData.receivingUserName,
			id: tempData.receivingUserId,
		}
		state.value.cooperation = {
			name: tempData.cooperationName,
			id: tempData.cooperationId,
		}
		state.value.product = {
			name: tempData.productName,
			id: tempData.productId,
		}
		state.value.productUnit = {
			name: tempData.productUnitName,
			id: tempData.productUnitCode,
		}
		state.value.productClass = {
			name: tempData.productClassName,
			id: tempData.productClassCode,
		}
	})
}
onMounted(() => {
	getAgentDeliverOrder()
})

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_cell_group, { inset: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            modelValue: state.value.orderId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (state.value.orderId = $event)),
            label: "关联采购单",
            readonly: "",
            placeholder: "自动生成"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.dispatchNoteId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (state.value.dispatchNoteId = $event)),
            label: "关联发货单",
            readonly: "",
            placeholder: "自动生成"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            label: "收货时间",
            placeholder: "请输入",
            readonly: "",
            required: ""
          }, {
            input: _withCtx(() => [
              _createElementVNode("div", {
                class: "picker",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (popShowFn('dateShow', true)))
              }, _toDisplayString(state.value.receivingTime), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_field, {
            modelValue: state.value.receivingUser.name,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (state.value.receivingUser.name = $event)),
            label: "委托收货人",
            readonly: "",
            placeholder: "自动生成",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.cooperation.name,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (state.value.cooperation.name = $event)),
            label: "供应商",
            readonly: "",
            placeholder: "自动生成",
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _hoisted_2,
      _createVNode(_component_van_cell_group, { inset: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            modelValue: state.value.warehouseName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (state.value.warehouseName = $event)),
            label: "仓库名",
            "error-message": state.value.warehouseNameErrMsg,
            placeholder: "请输入",
            required: ""
          }, null, 8, ["modelValue", "error-message"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.sn,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (state.value.sn = $event)),
            label: "批次号",
            placeholder: "请输入"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.product.name,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (state.value.product.name = $event)),
            label: "商品名",
            readonly: "",
            placeholder: "自动生成",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.productClass.name,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (state.value.productClass.name = $event)),
            label: "商品类别",
            readonly: "",
            placeholder: "自动生成",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.number,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (state.value.number = $event)),
            label: "货物件数",
            maxlength: 10,
            "error-message": state.value.numberErrMsg,
            type: "number",
            placeholder: "请输入",
            required: ""
          }, {
            "right-icon": _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["modelValue", "error-message"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.deliveryQuantity,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (state.value.deliveryQuantity = $event)),
            label: "到仓数量",
            maxlength: 10,
            type: "number",
            "error-message": state.value.deliveryQuantityErrMsg,
            placeholder: "请输入",
            required: ""
          }, {
            "right-icon": _withCtx(() => [
              _createTextVNode(_toDisplayString(state.value.productUnit.name), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "error-message"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.deliveryGrossWeight,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (state.value.deliveryGrossWeight = $event)),
            label: "到仓毛重",
            maxlength: 10,
            type: "number",
            placeholder: "请输入"
          }, {
            "right-icon": _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.deliveryNetWeight,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (state.value.deliveryNetWeight = $event)),
            label: "到仓净重",
            maxlength: 10,
            type: "number",
            placeholder: "请输入"
          }, {
            "right-icon": _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.deliveryTemperature,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (state.value.deliveryTemperature = $event)),
            "error-message": state.value.deliveryTemperatureErrMsg,
            label: "到仓温度",
            type: "number",
            placeholder: "请输入",
            maxlength: 10,
            required: ""
          }, {
            "right-icon": _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["modelValue", "error-message"]),
          _createVNode(_component_van_field, {
            modelValue: state.value.remark,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (state.value.remark = $event)),
            label: "备注",
            type: "textarea",
            maxlength: 255,
            autosize: "",
            placeholder: "请输入"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _hoisted_7,
      _createVNode(_component_van_cell_group, { inset: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            label: "装车情况",
            border: false,
            required: "",
            readonly: ""
          }),
          _createElementVNode("div", {
            class: _normalizeClass(['pic-tip', { 'red-color': state.value.loadingConditionImgErrMsg }])
          }, "（至少2张，照片需带时间水印）", 2),
          _createVNode(_component_stcp_h5_uploader, {
            modelValue: state.value.loadingConditionImg,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (state.value.loadingConditionImg = $event)),
            multiple: "",
            "after-read": imageUploadAfter,
            onDelete: _cache[16] || (_cache[16] = ($event: any) => (onDeleteImg(_ctx.$,1))),
            "max-count": 9,
            onPoster: _cache[17] || (_cache[17] = ($event: any) => (onClickImgPoster(_ctx.$,1))),
            class: "upload"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            label: "包装情况",
            border: false,
            required: "",
            readonly: ""
          }),
          _createElementVNode("div", {
            class: _normalizeClass(['pic-tip', { 'red-color': state.value.packingConditionImgErrMsg }])
          }, "（至少2张，照片需带时间水印）", 2),
          _createVNode(_component_stcp_h5_uploader, {
            modelValue: state.value.packingConditionImg,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (state.value.packingConditionImg = $event)),
            multiple: "",
            "after-read": imageUploadAfter,
            onDelete: _cache[19] || (_cache[19] = ($event: any) => (onDeleteImg(_ctx.$,2))),
            "max-count": 9,
            onPoster: _cache[20] || (_cache[20] = ($event: any) => (onClickImgPoster(_ctx.$,2))),
            class: "upload"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            label: "商品外观",
            border: false,
            required: "",
            readonly: ""
          }),
          _createElementVNode("div", {
            class: _normalizeClass(['pic-tip', { 'red-color': state.value.appearanceImgErrMsg }])
          }, "（至少2张，照片需带时间水印）", 2),
          _createVNode(_component_stcp_h5_uploader, {
            modelValue: state.value.appearanceImg,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (state.value.appearanceImg = $event)),
            multiple: "",
            "after-read": imageUploadAfter,
            onDelete: _cache[22] || (_cache[22] = ($event: any) => (onDeleteImg(_ctx.$,3))),
            "max-count": 9,
            onPoster: _cache[23] || (_cache[23] = ($event: any) => (onClickImgPoster(_ctx.$,3))),
            class: "upload"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            label: "商品糖度测试",
            border: false,
            required: "",
            readonly: "",
            "label-width": "8em"
          }),
          _createElementVNode("div", {
            class: _normalizeClass(['pic-tip', { 'red-color': state.value.sugarImgErrMsg }])
          }, "（至少2张，照片需带时间水印）", 2),
          _createVNode(_component_stcp_h5_uploader, {
            modelValue: state.value.sugarImg,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (state.value.sugarImg = $event)),
            multiple: "",
            "after-read": imageUploadAfter,
            onDelete: _cache[25] || (_cache[25] = ($event: any) => (onDeleteImg(_ctx.$,4))),
            "max-count": 9,
            onPoster: _cache[26] || (_cache[26] = ($event: any) => (onClickImgPoster(_ctx.$,4))),
            class: "upload"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_field, {
            label: "其他",
            border: false,
            readonly: ""
          }),
          _createVNode(_component_stcp_h5_uploader, {
            modelValue: state.value.otherImg,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (state.value.otherImg = $event)),
            multiple: "",
            "after-read": imageUploadAfter,
            onDelete: _cache[28] || (_cache[28] = ($event: any) => (onDeleteImg(_ctx.$,5))),
            "max-count": 9,
            onPoster: _cache[29] || (_cache[29] = ($event: any) => (onClickImgPoster(_ctx.$,5))),
            class: "upload"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_popup, {
      onClose: _cache[32] || (_cache[32] = ($event: any) => (popShowFn('dateShow', false))),
      show: state.value.dateShow,
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: state.value.currentDate,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (state.value.currentDate = $event)),
          type: "datetime",
          title: "验收时间",
          onCancel: _cache[31] || (_cache[31] = ($event: any) => (popShowFn('dateShow', false))),
          onConfirm: confirmDateSelect,
          "min-date": state.value.minDate,
          "max-date": state.value.maxDate
        }, null, 8, ["modelValue", "min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"]),
    (state.value.hideshow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            onClick: postInfo,
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})